import { useEffect, useState } from 'react'
import {
    MAX_OUTPUT_VIDEO_ASPECT_RATIO,
    MIN_OUTPUT_VIDEO_ASPECT_RATIO,
    MIN_OUTPUT_VIDEO_DIMENSION,
} from '../../../constants'
import CreationToolError from '../../../types/error'
import CreationToolOutputType from '../../../types/output-type'
import { SourceEditorEdits } from '../types'

export function useError(outputType: CreationToolOutputType, edits?: SourceEditorEdits): CreationToolError | undefined {
    const [error, setError] = useState<CreationToolError | undefined>()

    useEffect(() => {
        const isClip = outputType === CreationToolOutputType.Video

        if (isClip && edits?.crop) {
            const aspectRatio = edits.crop.width / edits.crop.height

            // crop too skinny
            if (edits.crop.width < MIN_OUTPUT_VIDEO_DIMENSION) {
                setError(CreationToolError.VideoWidthTooSmall)
                return
            }

            // crop too short
            if (edits.crop.height < MIN_OUTPUT_VIDEO_DIMENSION) {
                setError(CreationToolError.VideoHeightTooSmall)
                return
            }

            // crop aspect ratio too small
            if (aspectRatio < MIN_OUTPUT_VIDEO_ASPECT_RATIO) {
                setError(CreationToolError.VideoAspectRatioTooSmall)
                return
            }

            // crop aspect ratio too big
            if (aspectRatio > MAX_OUTPUT_VIDEO_ASPECT_RATIO) {
                setError(CreationToolError.VideoAspectRatioTooBig)
                return
            }
        }

        setError(undefined)
    }, [edits, outputType, setError])

    return error
}
